/** 停用产品指令 */
angular.module('disableTheProduct', []).directive('disableTheProduct', function() {
    return {
        restrict: 'AE',
        replace: true,
        templateUrl: './manageConfig/productManageMent/directive/disableTheProduct/disableTheProduct.html',
        scope: {
            item: '=',
            trench: '@',
            status: '=',
            callback: '&'
        },
        controller: function($scope, $q, editingMediatype, modalDialog, trsHttpService) {
            initStatus();
            initData();

            /**
             * [initStatus description]初始化状态
             *
             * @return  {[type]}  [return description]
             */
            function initStatus() {
                $scope.params = {
                    serviceid: 'zmy_product',
                    methodname: 'doEnableOrDisableProducts',
                    isEnable: !$scope.status,
                    MediaType: editingMediatype[$scope.trench],
                    ProductIds: $scope.item.BAIJIAHAOACCOUNTID || $scope.item.KUAIBAOACCOUNTID || $scope.item.DOUYINACCOUNTID || $scope.item.BAIJIAHAOACCOUNTID || $scope.item.ACCOUNTID || $scope.item.CHANNELID,
                };
            }
            
            /**
             * [initData description]初始化请求
             *
             * @return  {[type]}  [return description]
             */
            function initData() {
                getTrenchInfo();
            }

            /**
             * [initData description]一些渠道有特殊情况
             *
             * @return  {[type]}  [return description]
             */
            function getTrenchInfo() {
                if ($scope.trench === 'weixin') {
                    $scope.params.ProductIds = $scope.item.CHANNELID;
                }
            }

            /**
             * [doEnableOrDisableProducts description]新媒体渠道产品启用停用方法
             *
             * @param   {[type]}  item    [item description]
             * @param   {[type]}  trench  [trench description]
             * @param   {[type]}  callback  [callback description]
             * @return  {[type]}          [return description]
             */
            $scope.doEnableOrDisableProducts = function (item) {
                var deffer = $q.defer();
                var tip = $scope.status ? '停用' : '启用';
                modalDialog.alertType('确认' + tip + '该产品吗？', '', 'ask', true, function () {
                    $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.params, 'get').then(
                        function () {
                            modalDialog.alertType(tip + '成功', '', 'success', false);
                            deffer.resolve();
                            $scope.callback();
                        },
                        function () {
                            deffer.reject();
                        });
                }, function () {
                    deffer.reject();
                });
                return deffer.promise;
            };
        }
    };
});
